import { render, staticRenderFns } from "./PhoneLink.vue?vue&type=template&id=56a14811&scoped=true&"
import script from "./PhoneLink.vue?vue&type=script&lang=js&"
export * from "./PhoneLink.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLink.vue?vue&type=style&index=0&id=56a14811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a14811",
  null
  
)

export default component.exports